module.exports = __webpack_public_path__ + "static/img/ptzs3.1a3e1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ptzs3.png
// module id = FhcN
// module chunks = 0